import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Fixture, Goal, Player, Resource } from "src/app/interfaces/Index";
import { FixtureService, GoalService, PlayerService, ResourceService } from "src/app/services/Index";
import moment from 'moment';
import "./ScoreboardGeneral.css";

type Props = {};
type State = {
	currentIndex: number;
	currentItem: Resource;
	fixture: Fixture;
	fixtureDate: Date;
	items: Resource[];
};
export class ScoreboardGeneral extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {currentItem: new Resource, fixture: new Fixture, fixtureDate: new Date, currentIndex: 0, items: [],};
	}

	componentDidMount() {
		this.getItems();	
		this.getFixture();	
		let loop = setInterval(() => this.setIndex(), 5000);
	}

	setIndex() {
		let index = this.state.currentIndex === this.state.items.length - 1 ? 0 : this.state.currentIndex + 1;
		let currentItem = this.state.items[index];
		this.setState({ currentIndex: index, currentItem: currentItem });
	  }
	
	render() {
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				{this.state.currentIndex == -1 ? this.renderFixture() : this.renderGeneral()}	
			</div>
		);
	}

	renderFixture(){
		// return(
		// 	<>
		// 	<h1>NEXT UP AT GP...</h1>
		// 	<Row>
		// 		<Col><img src={"https://www.scunthorpe-united.co.uk/static/css/teams/badges/png/scunthorpe.png"} height="225"/></Col>
		// 		<Col><img src={this.state.fixture?.team?.badgeUrl} height="225"/></Col>
		// 	</Row>
		// 	<Row style={{paddingLeft:"30%",paddingRight:"30%", marginBottom:"10px"}}><img src={"https://sufc.blob.core.windows.net/uploads/Vanarama.png"}/></Row>
		// 	<Row><h2 style={{fontSize:35}}>{moment(this.state.fixtureDate).format("dddd, MMMM Do - hA")}</h2></Row>
		// 	</>
		// )
		return(
			<>
			<h1 style={{fontSize:"30pt"}}>Thank you to all for your support this season!</h1>
			<Row>
				<Col><img src={"https://www.scunthorpe-united.co.uk/static/css/teams/badges/png/scunthorpe.png"} height="225"/></Col>
			</Row>
			<Row style={{paddingLeft:"30%",paddingRight:"30%", marginBottom:"10px"}}><img src={"https://sufc.blob.core.windows.net/uploads/Vanarama.png"}/></Row>
			{/* <Row><h2 style={{fontSize:35}}>{moment(this.state.fixtureDate).format("dddd, MMMM Do - hA")}</h2></Row> */}
			</>
		)
	}

	renderGeneral(){
		return(
			<>
			<Row style={{width:576,height:432, position:"absolute", top:0, left:0}}>
					<Col><img src={this.state.currentItem.resourceUrl} height="432" width="576"/></Col>
					</Row>		
			</>
		);
	}
	
	async getFixture(){
		const res = await safeJson(FixtureService.getNext());
		if (res && res.error) {
		}
		let newDate = new Date(res.fixtureDateTime);
		if (res) this.setState({fixture:res, fixtureDate: newDate});
	}

	async getItems(){
		const res = await safeJson(ResourceService.getGeneral());
		if (res && res.error) {
		}

		let allItems: Resource[] = res
		this.setState({items: allItems, currentItem: allItems[0]});
	}
}